import appConfig from "./appConfig.json";

export const activeTheme = "ui";

const selectedConfig = appConfig[activeTheme];

export const config = {
  login: {
    background: selectedConfig.images.loginBackground,
    logo: selectedConfig.images.loginLogo,
    title: selectedConfig.texts.organizationName,
    social: {
      linkedin: "#",
      twitter: "#",
      eitta: "#"
    }
  },
  logo: selectedConfig.images.mainLogo,
  appConfig: selectedConfig
};